// VicTech #710 — 「转真人」计数核心(纯逻辑,无 DOM,便于单测)。
// N = 当前登录 agent 可见、带 need-human 标签、status=open 的对话数。
// 「处理完」三种任一:agent 在该对话公开回覆一句 / resolve(或离开 open)/ 移除 need-human 标签。
import { NEED_HUMAN_LABEL } from './constants';

const OUTGOING = 1;
const DEFAULT_SUPPRESS_MS = 30000;

const key = id => String(id);

export const isNeedHuman = conversation =>
  !!conversation &&
  conversation.status === 'open' &&
  Array.isArray(conversation.labels) &&
  conversation.labels.includes(NEED_HUMAN_LABEL);

export const isHumanReply = message => {
  if (!message || message.private) return false;
  if (Number(message.message_type) !== OUTGOING) return false;
  if (message.sender_type) return message.sender_type === 'User';
  return message.sender?.type === 'user';
};

export class NeedHumanTracker {
  constructor({
    now = () => Date.now(),
    suppressMs = DEFAULT_SUPPRESS_MS,
  } = {}) {
    this.now = now;
    this.suppressMs = suppressMs;
    this.ids = new Set();
    // id -> 被本地判定「已处理」的时间;窗口内忽略「标签还在」的旧讯息(伺服器端移除标签是异步的)
    this.handledAt = new Map();
  }

  get count() {
    return this.ids.size;
  }

  isSuppressed(id) {
    const at = this.handledAt.get(id);
    if (at === undefined) return false;
    if (this.now() - at < this.suppressMs) return true;
    this.handledAt.delete(id);
    return false;
  }

  applySnapshot(idList) {
    const next = new Set();
    idList.forEach(raw => {
      const id = key(raw);
      if (!this.isSuppressed(id)) next.add(id);
    });
    const added = [...next].filter(id => !this.ids.has(id));
    const removed = [...this.ids].filter(id => !next.has(id));
    this.ids = next;
    const toOut = list =>
      list.map(id => (Number.isNaN(Number(id)) ? id : Number(id)));
    return { added: toOut(added), removed: toOut(removed) };
  }

  // 回 'added' | 'removed' | null
  onConversation(conversation) {
    if (!conversation || conversation.id === undefined) return null;
    const id = key(conversation.id);
    if (isNeedHuman(conversation)) {
      if (this.isSuppressed(id) || this.ids.has(id)) return null;
      this.ids.add(id);
      return 'added';
    }
    // 伺服器已确认移除 → 解除抑制,之后真的再转人立刻算
    this.handledAt.delete(id);
    if (this.ids.delete(id)) return 'removed';
    return null;
  }

  // VicTech #710-kimi:对话不在本 agent 可见收件箱 → 若在计数里就拿掉(不当「已处理」,不设抑制)
  drop(rawId) {
    const id = key(rawId);
    return this.ids.delete(id) ? 'removed' : null;
  }

  onMessage(message) {
    if (!isHumanReply(message)) return null;
    const id = key(message.conversation_id);
    if (!this.ids.has(id)) return null;
    this.ids.delete(id);
    this.handledAt.set(id, this.now());
    return 'removed';
  }

  reset() {
    this.ids = new Set();
    this.handledAt = new Map();
  }
}
